// extracted by mini-css-extract-plugin
module.exports = {"wrap":"advisorChartBlock_wrap__DQ55l","title":"advisorChartBlock_title__3K7_m","chartBody":"advisorChartBlock_chartBody__2EPl1"};